export const WEB_MESSENGER_BUTTON = 'web-messenger-button';
